import { APP_ENV } from './appEnv';

/**
 * Microsoft Clarity session recordings on every page of the CMS, prod only (off on dev / local).
 * Loaded with Clarity's official snippet rather than the npm package. Inputs that hold secrets
 * (passwords, login codes, payment-provider keys) carry `CLARITY_MASK` so they are never recorded.
 */

// Public project id: the default lets prod work without an .env change.
const PROJECT_ID = process.env.REACT_APP_CLARITY_ID || 'z8q02hqgdo';

const enabled = !!PROJECT_ID && APP_ENV === 'prod' && typeof window !== 'undefined';

/** Spread on an input (MUI `inputProps`) or a wrapper / form to hide it from the recordings. */
export const CLARITY_MASK = { 'data-clarity-mask': 'true' };

const call = (...args) => {
    if (enabled && typeof window.clarity === 'function') window.clarity(...args);
};

/** Injects the Clarity tag once; calls made before it loads are queued. */
export const initClarity = () => {
    if (!enabled || window.clarity) return;
    window.clarity = function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
    };
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.clarity.ms/tag/${PROJECT_ID}`;
    const first = document.getElementsByTagName('script')[0];
    if (first && first.parentNode) first.parentNode.insertBefore(script, first);
    else document.head.appendChild(script);
    call('set', 'app_env', APP_ENV);
};

/** Makes the store's sessions searchable by store UUID (same id as Mixpanel's distinct_id). */
export const clarityIdentify = (storeId) => {
    if (storeId) call('identify', String(storeId));
};

/** Custom tag to filter recordings (skips empty values). */
export const claritySet = (key, value) => {
    if (value === undefined || value === null || value === '') return;
    call('set', key, String(value));
};

/** Custom event, shows up on the recording's timeline. */
export const clarityEvent = (name) => {
    if (name) call('event', name);
};
